import { toast } from 'react-toastify';

const configs = {
    position: toast.POSITION.TOP_RIGHT,
    autoClose:3000
};

export const ToasterConfigurations = configs;